<template>
  <div class="home">
    <div class="banner-content"><!-- :style="{height:screenHeight}"-->
      <div class="content_info">
        <div class="content">
          <h3>人生成功路</h3>
          <h3>志愿第一步</h3>
        </div>
        <img :src="teacherImg">
      </div>

      <!--<img :src="imgSrc" class="banner-img">-->
      <!--<el-image src="https://oss.kaoyanvip.cn/attach/file1705395901773.png" lazy class="banner-img"></el-image>-->
    </div>
    <!--资讯中心-->
    <div class="news-center-content">
      <news-center></news-center>
    </div>
    <!--暖峰行动-->
    <div class="public-introduce-content">
      <public-introduce></public-introduce>
    </div>
    <!--公司简介-->
    <div class="company-content">
      <company-content></company-content>
    </div>
    <!--企业布局-->
    <!--<div class="service-layout">
      <service-layout></service-layout>
    </div>-->
    <!--我们的价值-->
    <!--<div class="service-reflect">
      <service-reflect></service-reflect>
    </div>-->
    <!--服务范围-->
    <div class="service-content">
      <service-content></service-content>
    </div>
    <!--专业老师团队-->
    <div class="teacher-team">
      <teacher-team></teacher-team>
    </div>
  </div>
</template>
 
<script>
import ServiceContent from "@/components/ServiceContent";
import TeacherTeam from "@/components/TeacherTeam";
import CompanyContent from "@/components/CompanyContent";
import NewsCenter from "@/components/NewsCenter";
import PublicIntroduce from '@/components/PublicIntroduce';
/*import ServiceLayout from "@/components/ServiceLayout";
import ServiceReflect from "@/components/ServiceReflect";*/
import banner from '@/assets/img/banner1.jpg';
import indexBanner from '@/assets/img/indexBanner.jpg';
import teacherImg from '@/assets/img/teacherName.png';
export default {
  name: "HelloWorld",
  components: {
    ServiceContent,
    TeacherTeam,
    CompanyContent,
    NewsCenter,
    PublicIntroduce,
    /*ServiceLayout,
    ServiceReflect,*/
  },
  data() {
    return {
      loading: false,
      caseList: [],
      isImg: true,
      videoSrc: "http://www.shkjem.com/video/kj.mp4",
      posterImg: "",
      banner:banner,
      screenHeight:null,
      imgSrc: indexBanner,//高清
      teacherImg:teacherImg
    };
  },
  created() {
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {

  },
  mounted() {
    const windowHeight = window.innerHeight;
    window.console.log(windowHeight)
    //const rootValue = windowHeight / 100; // Change this calculation as needed

    // Set the dynamicHeight value based on your design logic
    // For example, you might use a percentage of the window height
    this.screenHeight = (windowHeight / 14) + 'rem';

  },
  methods:{
    showVideo(){
      this.isImg = false;
    },
    onLoadImg(imgSrc){
      return 'this.src='+'"'+imgSrc+'";this.onload=null';
      //this.hideImg = true;
    }
  }
};
</script>
 
<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868791.otf');
}
.home{
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .banner-content{
    width: 100%;
    background-image: url("../assets/img/banner1.jpg");
    background-size: cover;
    background-position: center;
    max-height: 960px;
    height: 960px;
    .content_info{
      width: 1200px;
      display: flex;
      padding-top: 260px;
      margin: 0 auto;
      justify-content: space-between;
      .content {
        position: relative;
        width: 1200px;
        margin-top: 30px;
        h3 {
          font-size: 66px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei';
          font-weight: bold;
          color: #0A0D0F;
          line-height: 90px;
          letter-spacing: 9px;
          margin-bottom: 20px;
        }
      }
      img{
        justify-content: flex-end;
        width: 40px;
        height: 165px;
        margin-top: 180px;
      }
    }

  }
  .banner-img{
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  .p-video{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    object-fit: fill;
  }
  .service-layout{
    width: 100%;
    height: 1085px;
    background-color: #F5F7FA;
  }
  .service-reflect{
    width: 100%;
    height: 848px;
    background: #FFFFFF;
  }
  .service-content{
    width: 100%;
    height: 750px;
    background: #F5F7FA;
  }
  .teacher-team{
    width: 100%;
    height: 950px;
    background-image: url('~@/assets/img/teacher-info-bg.jpg');
    position: relative;
    z-index: 1000;
    /*margin-top: -120px;*/
    background-size: 100% 100%;
    /*top: 1720px;
    position: absolute;*/
  }
}
video{
  object-fit: fill;
  object-position: center center;
  width: 100%;
  height: 100%;
}
</style>